<script>
export default {
	props: {
		telefones: Array
	},
	data: function() {
		return {
			mTelefones: this.telefones,
			isLoading: false,
			emailError: false
		};
	},
	mounted: function(){
		if(this.telefones.length == 0)
		{
			this.mTelefones.push({
				titulo: "",
				valor: ""
			});
		}
	},
	methods: {
		addTelefone: function(event) {
			this.mTelefones.push({
				titulo: "",
				valor: ""
			});
		},
		removeTelefone: function(event, index) {
			this.mTelefones.splice(index, 1);
		},
		validateEmail: function(event) {
			var vm = this;

			this.isLoading = true;

			this.axios
				.get(API_URL + '/meu-cadastro/validate-email', {
					params: {
						email: event.target.value
					}
				})
				.then(response => {
					//console.log(response)
				})
				.catch(function (error) {
				    if (error.response.status == 422) {
				    	vm.emailError = error.response.data.email;

				    	vm.$toasted.error(error.response.data.email[0], {duration:3000, keepOnHover: true, icon:'exclamation-circle'});
				    }
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}
	}
};
</script>